import AllPointsActivity from './AllPointsActivity.f';
import { withAllPointsActivity } from 'viewModel/content/BeautyInsider/BeautyInsiderModules/AllPointsActivity/withAllPointsActivity';

export default withAllPointsActivity(AllPointsActivity);
